<template>
  <div
    id="informModal"
    class="modal fade"
    :class="{ in: isShowModal, active: isShow }"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    v-show="isShow"
  >
    <div class="modal-bg" @click="onModalClose"></div>
    <div class="modal-dialog">
      <div class="modal-content">
        <template v-if="!isImage">
          <div  class="m-logo">
            <img
              src="https://resource.rcclchina.com.cn/Home/new/logo-modal.png"
            />
          </div>
          <div class="m-title" >{{ title }}</div>
        </template>
        <div
          class="common-modal-close"
          data-dismiss="modal"
          aria-label="Close"
          @click="onModalClose"
        >
          <img
            class="common-modal-close"
            src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/modal-close.jpg"
          />
        </div>

        <div class="modal-body">
          <!-- 图片版弹窗 -->
          <img
            v-if="isImage"
            class="m-image"
            :src="imageUrl"
            @click="onImageClick"
          />
          <!-- 文字版弹窗 -->
          <template v-else>
            <div class="parah" v-html="message"></div>
            <a class="m-link" @click="readMessage">我知道了</a>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import api from "@/api";
import { gioAdsTracking } from "@/utilities/tools";
import { getToken } from "@/utilities/userToken";
export default {
  name: "EmergencyMessageAlert",
  data() {
    return {
      isShowModal: false,
      isShow: false,
      isImage: false,
      imageUrl: "",
      message: "",
      title: "",
      link: "",
    };
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      this.showMessage();
    },
    async showMessage() {
      // 维护弹窗：popupMessageType = 1，无频控，有维护信息即弹出
      const isMaintain = await this.fetchPopup(1, false);
      if (isMaintain) {
        return;
      }

      // 普通弹窗：popupMessageType = 2，每天显示一次（cookie 频控）
      await this.fetchPopup(2, true);
    },
    // 统一走 GetStationPopupInfo 拉取弹窗信息（对齐小程序 setCmsPopupInfo 逻辑）
    // popupMessageType: 1 维护弹窗 / 2 普通弹窗；useCookie: 是否启用每天一次频控
    // 图片版：popupType === '图片' 直接展示 pictureUrl_Pc，点击跳 jumpLink_Pc
    async fetchPopup(popupMessageType, useCookie) {
      try {
        const { success, data } = await api.page.getStationPopupInfo({
          userName: getToken() || "",
          source: "online",
          popupMessageType
        });
        if (!success || !data) {
          return false;
        }

        const isImage = data.popupType === "图片";
        const content = isImage ? data.pictureUrl_Pc : data.textContent;
        if (!content) {
          return false;
        }

        if (useCookie) {
          const isPopuped = Cookies.get("rcclinformModal", { path: "/" });
          if (isPopuped && isPopuped.length > 0) {
            return false;
          }
        }

        this.isImage = isImage;
        this.imageUrl = isImage ? data.pictureUrl_Pc : "";
        this.message = isImage ? "" : data.textContent;
        this.title = isImage|| popupMessageType === 2? "" :  "维护通知";
        if (data.isSetJump && data.jumpLink_Pc) {
          this.link = data.jumpLink_Pc;
        }
        this.isShow = true;

        if (useCookie) {
          Cookies.set("rcclinformModal", data.id, { expires: 1 });
        }
        return true;
      } catch (e) {
        // 接口异常静默处理
      }
      return false;
    },
    // 图片版：点击图片跳转（对齐小程序 couponPopupLink），无跳转则关闭
    onImageClick() {
      if (this.link && this.link.length > 0) {
        window.open(this.link);
      }
      this.onModalClose();
    },
    onModalClose() {
      this.isShowModal = false;
      setTimeout(() => {
        this.isShow = false;
      }, 100);
    },
    readMessage() {
      if (this.link && this.link.length > 0) {
        location.open(this.link);
      }

      this.onModalClose();
			gioAdsTracking({
				"adsType": "pp"
			})
    },
  },
  watch: {
    isShow(newValue) {
      setTimeout(() => {
        this.isShowModal = newValue;
      }, 100);
    },
  },
};
</script>


<style lang="less" scoped>
.modal-dialog {
  top: 50px;
}

.modal {
  .modal-content {
    min-width: 650px;
    border-radius: 8px;
    position: relative;
    padding-top: 20px;
    box-sizing: border-box;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 10px;
  }

  .common-modal-close {
    position: absolute;
    width: 28px;
    top: 3px;
    right: 5px;
    z-index: 2;
    cursor: pointer;
  }
  .m-logo {
    text-align: center;
  }
  .m-title {
    position: relative;
    left: -3.5%;
    width: 107%;
    height: 56px;
    text-align: center;
    font-size: 26px;
    line-height: 56px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .modal-body {
    padding: 0px 30px 15px 30px;
    .m-link {
      display: block;
      width: 168px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      font-size: 20px;
      font-weight: 400;
      color: #282b2c;
      margin: 0 auto;
      background: #fbc500;
      margin-top: 40px;
      cursor: pointer;
    }
  }
}

.modal.active {
  display: block;
}

.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>

<style lang="less">
#informModal .modal-body {
  .parah {
    font-size: 14px;
    font-weight: 400;
    color: #282b2c;
    line-height: 26px;
    margin-bottom: 9px;
    overflow-y: auto;
    max-height: 52vh;
  }

  .m-image {
    display: block;
    max-width: 100%;
    // 笔记本屏幕高度有限，限制图片最大高度（预留弹窗标题/关闭按钮/边距空间），保持比例缩放
    max-height: calc(100vh - 140px);
    margin: 0 auto;
    cursor: pointer;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
    margin: 0 auto;
  }
}
</style>